import { supabase } from '../supabaseClient';

function financeError(error) {
  if (['PGRST202', '42P01', '42883'].includes(error?.code)) {
    return new Error('O painel de entradas e saídas precisa ser atualizado no banco. Nenhum dado foi alterado.');
  }
  return new Error(error?.message || 'Não foi possível consultar as entradas e saídas. Tente atualizar os dados.');
}
export async function loadPropertyFinance(propertyId) {
  const result = { movements: [], permissions: null, legacyCount: 0 };
  const ids = new Set();
  let offset = 0;
  while (true) {
    const { data, error } = await supabase.rpc('desempenho_financeiro_painel', { p_propriedade: propertyId, p_offset: offset });
    if (error) throw financeError(error);
    if (data?.version !== 3) throw new Error('Atualize a integração de indicadores da atividade no banco antes de usar as métricas.');
    if (!Array.isArray(data.movements) || !Number.isSafeInteger(data.legacyCount) || data.legacyCount < 0 || !data.permissions
      || !['create', 'edit', 'delete'].every(key => typeof data.permissions[key] === 'boolean')) {
      throw new Error('Resposta financeira incompleta. Não é seguro calcular as métricas. Atualize os dados.');
    }
    result.permissions = data.permissions;
    result.legacyCount = data.legacyCount;
    for (const movement of data.movements) {
      if (!movement?.id || ids.has(movement.id)) throw new Error('Consulta financeira inconsistente. Atualize os dados para evitar lançamentos repetidos.');
      ids.add(movement.id); result.movements.push(movement);
    }
    if (data.movements.length < 200) return result;
    offset += 200;
  }
}
export async function registerPropertyFinance(propertyId, action, payload, requestKey) {
  const { data, error } = await supabase.rpc('desempenho_financeiro_registrar', {
    p_propriedade: propertyId, p_acao: action, p_dados: payload, p_chave: requestKey,
  });
  if (error) throw financeError(error);
  if (data?.registrado !== true || !data.id) throw new Error('Gravação financeira não confirmada. Tente novamente sem alterar os campos.');
  return data;
}
